module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921051149_T.9183fcec.jpg";